import moment, { duration } from "moment";
import { useMemo, useState } from "react";
import ExtendModal from "./ExtendModal";

const VoucherInfo = ({ data, id, reload }) => {
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState();

  const btns = useMemo(() => {
    if (!data?.extension_options || data?.extension_options?.length === 0)
      return;

    return data?.extension_options
      ? Object.entries(data?.extension_options?.buttons).flatMap(
          ([key, value]) => {
            const result = {};
            result["name"] = key;
            result["value"] = value;
            result["duration"] = key.includes("6") ? 6 : 12;

            return result;
          }
        )
      : {};
  }, [data?.extension_options]);

  const handleExtend = (value) => {
    if (value.name === "Invoice") return window.open(value.value, "_blank");
    setShowModal(true);
    setAmount({ amount: value.value, duration: value.duration });
  };

  if (
    !data.voucher ||
    !data?.extension_options ||
    data?.extension_options === 0
  )
    return null;

  return (
    <>
      <div className="reedem-voucher__info">
        <div>
          <div
            className="d-grid"
            style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
          >
            <strong>Voucher Code:</strong>
            <span>{data?.voucher?.code}</span>
          </div>
          <div
            className="d-grid"
            style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
          >
            <strong>Winner:</strong>
            <span>
              {data?.voucher?.first_name} {data?.voucher?.last_name}
            </span>
          </div>
          <div
            className="d-grid"
            style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
          >
            <strong>Date Issued:</strong>
            <span>
              {moment(data?.voucher?.datetime_issued).format("DD MMM YYYY")}
            </span>
          </div>
          <div
            className="d-grid"
            style={{ gridTemplateColumns: "repeat(2, 1fr)" }}
          >
            <strong>Vouched Expiry Date:</strong>
            <span>
              {moment(data?.voucher?.voucher_expiry_date).format("DD MMM YYYY")}
            </span>
          </div>
        </div>
        <div className="d-flex flex-column align-items-center pt-md-0 pt-2">
          <span>{data?.extension_options?.message}</span>
          {btns?.map((el, idx) => (
            <button
              className="px-2 py-2 w-75 mt-1 buttony-gold text-dark badge"
              key={idx}
              onClick={() => handleExtend(el)}
            >
              {el.name}
            </button>
          ))}
        </div>
      </div>

      <ExtendModal
        id={id}
        email={data?.voucher?.email}
        amount={amount}
        show={showModal}
        close={() => setShowModal(false)}
        reload={reload}
      />
    </>
  );
};

export default VoucherInfo;
